import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NetworkWithToken from "../../../config/networkwithtoken";
import { apiresponseType } from "src/config/helper";
import Configuration from "src/config/configuration";

export const uploadSection = createAsyncThunk(
  "uploadSection",
  async (data: {}) => {
    try {
      const response = await NetworkWithToken.post(
        Configuration.apis.uploadSectionForm,
        data,
      );
      if (response.status) {
        const resultData = response.data;
        return resultData;
      }
    } catch (err) {
      console.log(err);
    }
  },
);

interface uploadSectionState {
  courseSection: apiresponseType;
  loading: boolean;
  error: any;
}

const uploadSectionInitialState: uploadSectionState = {
  courseSection: {
    data: {},
    error: "",
    message: "",
    status: false,
    statusCode: 0,
  },
  loading: false,
  error: {},
} satisfies uploadSectionState as uploadSectionState;

const uploadSectionSlice = createSlice({
  name: "uploadSectionSlice",
  initialState: uploadSectionInitialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(uploadSection.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(uploadSection.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.courseSection = action.payload;
      })
      .addCase(uploadSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.courseSection = {
          data: {},
          error: "",
          message: "",
          status: false,
          statusCode: 0,
        };
      });
  },
});

export default uploadSectionSlice.reducer;
